import { gql } from "@apollo/client";
import moment from 'moment';

export const GET_ESTADOS_HISTORIAL = gql`
query GetEstadosHistorial($idSolicitud: Int!) {
    traditumBitacora(idSolicitud: $idSolicitud) {
        success,
        error,
        valorEsperado {
            idBitacora
            idSolicitud
            idEstado
            descripcionEstado
            fecha
            observacion
        }
    }
}`;

export const adaptEstado = (estado) => {
  return {
    ...estado,
    fecha: moment(estado.fecha).format("yyyy-MM-DD")
  };
};

export const adaptEstadosBitacoraArray = (
valorEsperado) =>
{
  return structuredClone(valorEsperado)?.
  map((estado) => adaptEstado(estado));
};